/**
 * Format post data for display
 * @param {Object} post - Raw post data
 * @returns {Object} Formatted post data
 */
export const formatPostData = (post) => {
  if (!post) return null
  
  // Create a formatted post object with defaults for missing properties
  return {
    id: post.id || '',
    content: post.content || '',
    platform: post.platform || '',
    platformIcon: getPlatformIcon(post.platform),
    createdAt: post.createdAt || '',
    formattedDate: formatPostDate(post.createdAt),
    stats: formatPostStats(post.stats),
    media: post.media || [],
    comments: post.comments || [],
    status: post.status || 'draft',
    // Add other formatted properties as needed
  }
}

/**
 * Get platform icon based on platform name
 * @param {string} platformName - Name of the platform
 * @returns {string} Icon URL or empty string
 */
const getPlatformIcon = (platformName) => {
  const icons = {
    instagram: require('@/assets/icons/instagram.svg'),
    facebook: require('@/assets/icons/facebook.svg'),
    twitter: require('@/assets/icons/twitterx.svg'),
    // Add other platforms as needed
  }
  
  return icons[platformName?.toLowerCase()] || ''
}

/**
 * Format post date
 * @param {string|number} timestamp - Post date timestamp
 * @returns {string} Formatted date string
 */
const formatPostDate = (timestamp) => {
  if (!timestamp) return ''
  
  try {
    const date = new Date(timestamp)
    return date.toLocaleDateString()
  } catch (e) {
    console.error('Error formatting post date:', e)
    return ''
  }
}

/**
 * Format post statistics
 * @param {Object} stats - Raw post statistics
 * @returns {Object} Formatted statistics
 */
const formatPostStats = (stats) => {
  if (!stats) return {}
  
  return {
    likes: formatStatNumber(stats.likes),
    comments: formatStatNumber(stats.comments),
    shares: formatStatNumber(stats.shares),
    views: formatStatNumber(stats.views),
    // Add other stats as needed
  }
}

/**
 * Format statistical numbers for display
 * @param {number} value - Statistical value
 * @returns {string} Formatted value
 */
const formatStatNumber = (value) => {
  if (value === undefined || value === null) return '0'
  
  if (value >= 1000000) {
    return `${(value / 1000000).toFixed(1)}M`
  }
  
  if (value >= 1000) {
    return `${(value / 1000).toFixed(1)}K`
  }
  
  return String(value)
}
